/* Tice Nits: gedrag van het mega menu (computer) en het uitklapmenu (gsm). Geen bibliotheken. */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const HOVER_DELAY = 150;

  function init(root) {
    if (root.__tnInit) return;
    root.__tnInit = true;

    const header = root.querySelector('.tn-header');
    const overlay = root.querySelector('[data-tn-overlay]');
    const burger = root.querySelector('[data-tn-burger]');
    const drawer = root.querySelector('[data-tn-drawer]');
    const closeBtn = root.querySelector('[data-tn-close]');
    const tabs = Array.from(root.querySelectorAll('[data-tn-tab]'));
    const tabBtn = (li) => li.querySelector('[data-tn-tab-btn]');
    const hasPanel = (li) => !!tabBtn(li);

    let current = null;
    let pinned = false;
    let timer = null;

    function placeOverlay() {
      if (!overlay || !header) return;
      root.style.setProperty('--tn-ov-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    }

    function setOpen(li, pin) {
      current = li;
      pinned = !!pin && !!li;
      tabs.forEach((t) => {
        const on = t === li;
        t.classList.toggle('is-open', on);
        const b = tabBtn(t);
        if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      root.classList.toggle('has-open', !!li);
      if (li && DESKTOP.matches) placeOverlay();
    }

    function closeAll(returnFocus) {
      clearTimeout(timer);
      const was = current;
      setOpen(null, false);
      if (returnFocus && was && tabBtn(was)) tabBtn(was).focus();
    }

    /* Tabs */
    tabs.forEach((li) => {
      const btn = tabBtn(li);

      li.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse' || !DESKTOP.matches) return;
        clearTimeout(timer);
        if (!hasPanel(li)) {
          if (current && !pinned) timer = setTimeout(() => closeAll(false), HOVER_DELAY);
          return;
        }
        if (current === li) return;
        timer = setTimeout(() => setOpen(li, pinned), current ? 60 : HOVER_DELAY);
      });

      if (!btn) return;
      btn.addEventListener('click', () => {
        clearTimeout(timer);
        if (DESKTOP.matches) {
          if (current === li) {
            if (pinned) closeAll(false);
            else pinned = true;
          } else {
            setOpen(li, true);
          }
        } else {
          const opening = current !== li;
          setOpen(opening ? li : null, false);
          if (opening) {
            const first = li.querySelector('[data-tn-col]');
            const panel = li.querySelector('.tn-panel');
            if (first && panel && panel.dataset.mobileCols === 'accordion' && !li.querySelector('[data-tn-col].is-open')) {
              setColOpen(first, true);
            }
          }
        }
      });
    });

    if (header) {
      header.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') clearTimeout(timer);
      });
      header.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse' || !DESKTOP.matches || pinned || !current) return;
        clearTimeout(timer);
        timer = setTimeout(() => closeAll(false), HOVER_DELAY);
      });
    }

    /* Kolommen (accordeon op gsm) */
    function setColOpen(col, open) {
      col.classList.toggle('is-open', open);
      const b = col.querySelector('[data-tn-col-btn]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    root.querySelectorAll('[data-tn-col]').forEach((col) => {
      const b = col.querySelector('[data-tn-col-btn]');
      if (!b) return;
      b.addEventListener('click', () => {
        const panel = col.closest('.tn-panel');
        const open = !col.classList.contains('is-open');
        if (panel) panel.querySelectorAll('[data-tn-col]').forEach((c) => setColOpen(c, false));
        setColOpen(col, open);
      });
    });

    /* Gsm-menu */
    function focusables() {
      return Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'))
        .filter((el) => el.offsetParent !== null);
    }
    function openDrawer() {
      root.classList.add('drawer-open');
      document.documentElement.classList.add('tn-menu-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      if (!current) {
        const first = tabs.find(hasPanel);
        if (first) {
          setOpen(first, false);
          const col = first.querySelector('[data-tn-col]');
          const panel = first.querySelector('.tn-panel');
          if (col && panel && panel.dataset.mobileCols === 'accordion') setColOpen(col, true);
        }
      }
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function closeDrawer(returnFocus) {
      if (!root.classList.contains('drawer-open')) return;
      root.classList.remove('drawer-open');
      document.documentElement.classList.remove('tn-menu-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (returnFocus && burger) burger.focus();
    }
    if (burger) burger.addEventListener('click', () => (root.classList.contains('drawer-open') ? closeDrawer(true) : openDrawer()));
    if (closeBtn) closeBtn.addEventListener('click', () => closeDrawer(true));

    if (drawer) {
      drawer.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || !root.classList.contains('drawer-open')) return;
        const f = focusables();
        if (!f.length) return;
        const first = f[0];
        const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    /* Algemeen */
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (root.classList.contains('drawer-open')) { closeDrawer(true); return; }
      if (current) closeAll(root.contains(document.activeElement));
    });
    document.addEventListener('click', (e) => {
      if (!current || !DESKTOP.matches) return;
      if (!e.target.closest('[data-tn-tab]')) closeAll(false);
    });
    root.addEventListener('focusout', (e) => {
      if (!DESKTOP.matches || !current) return;
      if (e.relatedTarget && !root.contains(e.relatedTarget)) closeAll(false);
    });
    let raf = 0;
    const update = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { if (current && DESKTOP.matches) placeOverlay(); });
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    DESKTOP.addEventListener('change', () => {
      closeDrawer(false);
      setOpen(null, false);
    });
  }

  const boot = () => document.querySelectorAll('[data-tn-header]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Zoeksuggesties (Broadcast predictive search in de zoekbalk van tn-header): vraag een vast aantal producten
   (instelling 'search_limit', standaard 8) plus collecties, pagina's en zoeksuggesties, elk apart geteld.
   Broadcast (theme.js) vraagt zonder resources-parameters; we vullen die hier aan zonder theme.js te wijzigen. */
(() => {
  if (!window.fetch || window.fetch.__tnSearch) return;
  const orig = window.fetch.bind(window);
  const tnFetch = function (input, init) {
    try {
      if (typeof input === 'string' && input.indexOf('section_id=predictive-search') > -1 && input.indexOf('resources%5B') < 0 && input.indexOf('resources[') < 0) {
        const root = (window.theme && window.theme.routes && window.theme.routes.predictive_search_url) || '/search/suggest';
        if (input.split('?')[0].replace(/\/$/, '').endsWith(root.replace(/\/$/, ''))) {
          const el = document.querySelector('[data-tn-search-limit]');
          const n = Math.min(10, Math.max(1, parseInt(el && el.getAttribute('data-tn-search-limit'), 10) || 8));
          const u = new URL(input, window.location.origin);
          u.searchParams.set('resources[type]', 'product,collection,page,query');
          u.searchParams.set('resources[limit]', String(n));
          u.searchParams.set('resources[limit_scope]', 'each');
          input = u.pathname + u.search;
        }
      }
    } catch (e) { /* bij twijfel de oorspronkelijke vraag */ }
    const isSearch = typeof input === 'string' && input.indexOf('section_id=predictive-search') > -1;
    const pr = orig(input, init);
    if (isSearch) pr.then(() => { setTimeout(fit, 60); setTimeout(fit, 700); }, () => {});
    return pr;
  };
  /* de suggestielijst nooit langer dan het scherm, zodat de knop naar alle resultaten onderaan zichtbaar blijft */
  function fit() {
    document.querySelectorAll('.tn-root .predictive-search').forEach((el) => {
      const top = el.getBoundingClientRect().top;
      if (top > 0) el.style.maxHeight = Math.max(240, Math.floor(window.innerHeight - Math.ceil(top))) + 'px';
    });
  }
  window.addEventListener('resize', fit, { passive: true });
  tnFetch.__tnSearch = true;
  window.fetch = tnFetch;
})();

/* Zoekvenster (Broadcast header-search-popdown in tn-header): één keer Esc sluit het hele venster (ook als de
   suggesties open staan) en de focus keert terug naar het zoekicoon. Bij openen meteen focus in het zoekveld,
   zodat de eerste letters niet verloren gaan tijdens de animatie. theme.js blijft ongewijzigd. */
(() => {
  const bind = (pop) => {
    if (pop.__tnEsc) return;
    pop.__tnEsc = true;
    const details = pop.querySelector('details');
    const summary = details && details.querySelector('summary');
    if (!details || !summary) return;
    let refocus = false;
    pop.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !details.hasAttribute('open')) return;
      e.preventDefault();
      e.stopPropagation();
      refocus = true;
      if (typeof pop.close === 'function') pop.close();
      else details.removeAttribute('open');
    }, true);
    pop.addEventListener('keyup', (e) => { if (e.key === 'Escape') e.stopPropagation(); }, true);
    const closeBtn = pop.querySelector('[data-popdown-close]');
    if (closeBtn) closeBtn.addEventListener('click', () => { refocus = true; });
    details.addEventListener('toggle', () => {
      if (details.hasAttribute('open')) {
        const input = details.querySelector('input[type="search"]');
        if (input) requestAnimationFrame(() => input.focus({ preventScroll: true }));
      } else if (refocus) {
        refocus = false;
        summary.focus({ preventScroll: true });
      }
    });
  };
  const boot = () => document.querySelectorAll('[data-tn-header] header-search-popdown').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
